// Copies a sent link's attribution onto a cart before it is saved: message_id
// (the exact send) and from= (email / phone). The server derives the cart's
// entry method from either -- message_id says "link" outright, and from=email
// or from=phone only exist inside sent messages (Cart::LOCATION_ENTRY_HINTS).
//
// Only what the URL actually carries is written, so a missing param never
// overwrites a value the cart already has.
export function applyLinkAttribution(cart, { messageId, from } = {}) {
  if (messageId) cart.messageId = messageId;
  if (from) cart.createdLocation = from;
  return cart;
}

export default applyLinkAttribution;
